var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jumbotron"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Sorry, you are not authorised to login to the app!")])])])
}]

export { render, staticRenderFns }